const initialState = {
  company: null,
  collectionBrand: null,
  companyName: null,
  registrationNumber: null,
  role: null,
  isHydrated: false,
};

const fleetCoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_FLEETCORE_CONTEXT": {
      const next = { ...state, isHydrated: true };
      const { company, collectionBrand, companyName, registrationNumber, role } =
        action.payload || {};
      if (company !== undefined) next.company = company;
      if (collectionBrand !== undefined) next.collectionBrand = collectionBrand;
      if (companyName !== undefined) next.companyName = companyName;
      if (registrationNumber !== undefined) next.registrationNumber = registrationNumber;
      if (role !== undefined) next.role = role;
      return next;
    }
    case "CLEAR_FLEETCORE_CONTEXT":
      return { ...initialState };
    default:
      return state;
  }
};

export default fleetCoreReducer;
